import Decimal from 'decimal.js'
import { LinkButton } from './Button'
import FormatNumericValue from './FormatNumericValue'
import { ReactNode } from 'react'

const MaxAmountButton = ({
  className = '',
  decimals,
  disabled,
  label,
  onClick,
  value,
}: {
  className?: string
  decimals?: number
  disabled?: boolean
  label?: string | ReactNode
  onClick: () => void
  value: number | string | Decimal
}) => {
  return (
    <LinkButton
      className={`font-normal text-th-fgd-4 md:hover:text-th-fgd-2 ${className}`}
      disabled={disabled}
      onClick={onClick}
    >
      {label ? <div className="mr-1">{label}</div> : null}
      <span className="font-mono">
        <FormatNumericValue value={value} decimals={decimals} />
      </span>
    </LinkButton>
  )
}

export default MaxAmountButton
